import api from './api';

const candidateService = {
  // Public - Get All Candidates
  getAllCandidates: async (params) => {
    const response = await api.get('/candidate', { params });
    return response.data;
  },

  // Public - Get Candidate Profile
  getCandidateProfile: async (id) => {
    const response = await api.get(`/candidate/${id}`);
    return response.data;
  },

  // Admin - Create Candidate
  createCandidate: async (data) => {
    const response = await api.post('/admin/candidate', data);
    return response.data;
  },

  // Admin - Get All Candidates (Admin View)
  getAdminCandidates: async (params) => {
    const response = await api.get('/admin/candidate', { params });
    return response.data;
  },

  // Admin - Get Candidate Details
  getCandidate: async (id) => {
    const response = await api.get(`/admin/candidate/${id}`);
    return response.data;
  },

  // Admin - Update Candidate
  updateCandidate: async (id, data) => {
    const response = await api.put(`/admin/candidate/${id}`, data);
    return response.data;
  },

  // Admin - Delete Candidate
  deleteCandidate: async (id) => {
    const response = await api.delete(`/admin/candidate/${id}`);
    return response.data;
  },

  // Admin - Download Sample CSV
  downloadSample: async () => {
    const response = await api.get('/admin/candidate/export/sample', {
      responseType: 'blob',
    });
    return response.data;
  },

  // Admin - Import Candidates
  importCandidates: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/admin/candidate/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Admin - Create Expenditure
  createExpenditure: async (id, data) => {
    const response = await api.post(`/admin/candidate/${id}/expenditure`, data);
    return response.data;
  },

  // Public/Admin - Get Expenditures
  getExpenditures: async (id) => {
    // Try public endpoint first, fallback to admin/authenticated if structure differs, 
    // but for now creating unified access pattern or separate.
    // Given the controller setup:
    // Public: /candidate/:id/expenditure
    // Admin: /admin/candidate/:id/expenditure (also works but public is broader)
    const response = await api.get(`/candidate/${id}/expenditure`);
    return response.data;
  },
};

export default candidateService;
